import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Chip, Collapse, ListItemButton, Typography } from '@mui/material'
import React, { useState } from 'react'

export default function Section(
  { title, count, defaultOpen, children }:
  { title: string; count: number; defaultOpen: boolean; children: React.ReactNode },
) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <>
      <ListItemButton
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        sx={{ py: 0.5, px: 2, borderRadius: 0 }}
      >
        <Typography
          variant="overline"
          sx={{ flex: 1, color: 'text.secondary', letterSpacing: 0.6, lineHeight: 2 }}
        >
          {title}
        </Typography>
        <Chip
          label={count}
          size="small"
          variant="outlined"
          sx={{ height: 18, mr: 1, '& .MuiChip-label': { px: 0.75, fontSize: 11 } }}
        />
        {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit={true}>
        {children}
      </Collapse>
    </>
  )
}
